import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../LanguageContext';
export const IntroCurtain = () => {
  const [show, setShow] = useState(true);
  const {
    language
  } = useLanguage();
  useEffect(() => {
    const original = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const timer = setTimeout(() => {
      setShow(false);
      document.body.style.overflow = original;
    }, 2400);
    return () => {
      clearTimeout(timer);
      document.body.style.overflow = original;
    };
  }, []);
  const EASE = [0.76, 0, 0.24, 1] as const;
  return <AnimatePresence data-id="element-342">
      {show && <div key="intro-curtain" className="fixed inset-0 z-[200] pointer-events-none" aria-hidden="true" data-id="element-343">
          {/* TOP panel — slides up */}
          <motion.div initial={{
        y: 0
      }} animate={{
        y: 0
      }} exit={{
        y: '-100%',
        transition: {
          duration: 1,
          ease: EASE
        }
      }} className="absolute top-0 left-0 right-0 h-1/2 bg-brand-ivory overflow-hidden" data-id="element-344">
            {/* Soft top vignette to mask any seam */}
            <div className="absolute inset-0 pointer-events-none" style={{
          background: 'radial-gradient(ellipse at bottom, rgba(201,167,124,0.18) 0%, rgba(201,167,124,0) 55%)'
        }} data-id="element-345" />
          </motion.div>

          {/* BOTTOM panel — slides down */}
          <motion.div initial={{
        y: 0
      }} animate={{
        y: 0
      }} exit={{
        y: '100%',
        transition: {
          duration: 1,
          ease: EASE
        }
      }} className="absolute bottom-0 left-0 right-0 h-1/2 bg-brand-ivory overflow-hidden" data-id="element-346">
            {/* Soft bottom vignette */}
            <div className="absolute inset-0 pointer-events-none" style={{
          background: 'radial-gradient(ellipse at top, rgba(201,167,124,0.18) 0%, rgba(201,167,124,0) 55%)'
        }} data-id="element-347" />
          </motion.div>

          {/* Thin gold hairline that traces along the meeting seam */}
          <motion.div initial={{
        scaleX: 0,
        opacity: 0
      }} animate={{
        scaleX: 1,
        opacity: [0, 1, 1]
      }} exit={{
        opacity: 0,
        transition: {
          duration: 0.4
        }
      }} transition={{
        duration: 0.9,
        delay: 0.1,
        ease: 'easeOut'
      }} className="absolute top-1/2 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-gold to-transparent origin-center -translate-y-px" data-id="element-348" />

          {/* Logo — feathered via radial mask so no rectangle shows */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.94
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        transition: {
          duration: 0.5
        }
      }} transition={{
        duration: 1,
        delay: 0.3,
        ease: 'easeOut'
      }} className="absolute inset-0 flex flex-col items-center justify-center gap-5" data-id="element-349">
            <div className="relative" data-id="element-350">
              {/* Soft gold halo behind the logo */}
              <div className="absolute -inset-16 pointer-events-none" style={{
            background: 'radial-gradient(circle, rgba(201,167,124,0.35) 0%, rgba(201,167,124,0.08) 35%, rgba(201,167,124,0) 65%)',
            filter: 'blur(6px)'
          }} data-id="element-351" />
              {/* Logo with radial mask — edges feather into background */}
              <img src="https://cdn.magicpatterns.com/uploads/4uPBzNpH6m9EY4gNp874BD/LOGO_SKIN_GLOW.png" alt="Skin Glow Studio 22" width={260} className="relative block h-auto" style={{
            width: 260,
            WebkitMaskImage: 'radial-gradient(ellipse 60% 55% at center, black 35%, transparent 80%)',
            maskImage: 'radial-gradient(ellipse 60% 55% at center, black 35%, transparent 80%)',
            filter: 'contrast(1.15) saturate(1.25)'
          }} data-id="element-352" />
            </div>

            <motion.p initial={{
          opacity: 0,
          y: 6
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 1,
          ease: 'easeOut'
        }} className="text-[10px] md:text-xs tracking-[0.5em] text-brand-bronze uppercase font-medium" data-id="element-353">
              {language === 'es' ? 'Spa · Belleza' : 'Spa · Beauty'}
            </motion.p>
          </motion.div>
        </div>}
    </AnimatePresence>;
};